import dayjs from 'dayjs'

import { formatCurrency } from "./functions";
import { getStandardFieldLabel, STANDARD_FIELD_MAP } from "./standard-fields";

const translatedStatus = {
    "ACTIVE": "Ativa",
    "QUALIFIED": "Qualificada",
    "CONQUERED": "Conquistada",
    "INACTIVE": "Inativa",
    "LOST": "Perdida"
}

const translatedKeys = {
    "column": "Estágio",
    "currency": "Moeda",
    "tags": "Marcadores",
    "position": "Posição no estágio",
    "custom_fields": "Campos Personalizados",
    "custom_fields_snapshot": "Campos Personalizados",
    "updated_at": "Última atualização",
    "archived": "Arquivado",
}

const getHistoryFieldName = (journey, key) => {
    if (STANDARD_FIELD_MAP[key]) {
        return getStandardFieldLabel(journey, key)
    }

    return translatedKeys[key] || key
}

const ignoredHistoryColumns = [
    "id",
    "created_at",
    "created_by",
    "history_id",
    "history_type",
    "history_user_id",
    "history_date",
    "updated_at",
    "position"
]

export const parseOpportunityHistoryRows = (data, board, currency, journey) => {
    const creationRow = data.find(row => row.history_type === "+")
    const initialRows = []

    if (creationRow) {
        const created = dayjs.utc(creationRow.history_date).local()
        const createdBy = creationRow.created_by || creationRow.history_user || "Sistema"
        initialRows.push({
            id: `created-${creationRow.history_id}`,
            platform_entrypoint: "OPPORTUNITY_CREATED",
            date: created.format("YYYY-MM-DD"),
            time: created.format("HH:mm"),
            update: `Oportunidade criada por ${createdBy}.`,
            created_at: creationRow.history_date
        })
    }

    return data.reduce((acc, row, index) => {
        if (index >= data.length - 1) return acc

        const next = data[index + 1]
        const created = dayjs.utc(row.history_date).local()
        const localDate = created.format("YYYY-MM-DD")
        const localTime = created.format("HH:mm")

        const changedFields = []
        changedFields.push(`<table class="opportunity-update-table">`)
        changedFields.push(`<thead><tr><th>Campo</th><th>Valor Anterior</th><th>Valor Atualizado</th></tr></thead>`)
        changedFields.push(`<tbody>`)

        Object.keys(row).forEach((key) => {
            if (!ignoredHistoryColumns.includes(key) && row[key] !== next[key]) {
                let prev = next[key] != null ? next[key] : ''
                let curr = row[key] != null ? row[key] : ''

                switch (key) {
                    case "estimated_at":
                    case "closed_at":
                    case "updated_at":
                        prev = prev ? dayjs.utc(prev).local().format('DD/MM/YYYY HH:mm') : prev
                        curr = curr ? dayjs.utc(curr).local().format('DD/MM/YYYY HH:mm') : curr
                        break
                    case "value":
                        prev = prev ? formatCurrency(prev, currency) : prev
                        curr = curr ? formatCurrency(curr, currency) : curr
                        break
                    case "column":
                        prev = prev ? (board.columns.find((column) => column.id === prev)?.title || "") : ""
                        curr = curr ? (board.columns.find((column) => column.id === curr)?.title || "") : ""
                        break
                    case "status":
                        prev = prev ? translatedStatus[prev] : prev
                        curr = curr ? translatedStatus[curr] : curr
                        break
                    case "contact_enterprise":
                        break
                    case "archived":
                        prev = prev === true || prev === "true" ? "Sim" : "Não"
                        curr = curr === true || curr === "true" ? "Sim" : "Não"
                        break
                    case "custom_fields_snapshot":
                        // Handle custom fields snapshot comparison
                        const prevSnapshot = prev ? (typeof prev === 'object' ? prev : JSON.parse(prev)) : {}
                        const currSnapshot = curr ? (typeof curr === 'object' ? curr : JSON.parse(curr)) : {}
                        const allFieldIds = new Set([
                            ...Object.keys(prevSnapshot),
                            ...Object.keys(currSnapshot)
                        ])
                        for (const fieldId of allFieldIds) {
                            const prevField = prevSnapshot[fieldId]
                            const currField = currSnapshot[fieldId]
                            if (JSON.stringify(prevField) !== JSON.stringify(currField)) {
                                const cfName = currField?.name || prevField?.name || `Campo ${fieldId}`
                                const fieldType = currField?.type || prevField?.type
                                let prevValue = prevField?.value ?? ''
                                let currValue = currField?.value ?? ''

                                // Format date fields
                                if (fieldType === 'date') {
                                    prevValue = prevValue ? dayjs.utc(prevValue).local().format('DD/MM/YYYY') : ''
                                    currValue = currValue ? dayjs.utc(currValue).local().format('DD/MM/YYYY') : ''
                                }

                                changedFields.push(`<tr><td>${cfName}</td><td>${prevValue}</td><td>${currValue}</td></tr>`)
                            }
                        }
                        return  // Skip default row push, we already added rows
                    default:
                        break
                }
                const fieldName = getHistoryFieldName(journey, key)

                changedFields.push(`<tr><td>${fieldName}</td><td>${prev}</td><td>${curr}</td></tr>`)
            }
        })

        changedFields.push(`</tbody></table>`)
        const updates = changedFields.length > 4 ? changedFields.join("\n") : ""

        if (updates) {
            acc.push({
                id: row.history_id,
                platform_entrypoint: (row.history_type === "+") ? "OPPORTUNITY_CREATED" : "OPPORTUNITY_UPDATED",
                date: localDate,
                time: localTime,
                update: updates,
                created_at: row.history_date
            })
        }

        return acc
    }, initialRows)
}
